import { StructuraAppLoadingScreen, FM_APP_LOADING_BRAND } from "@/components/StructuraAppLoadingScreen";
import { cn } from "@/lib/utils";

interface PageLoaderProps {
  label?: string;
  variant?: "screen" | "inline";
  className?: string;
}

/** Carga estándar — mismo loader que sesión / impersonación. */
export function PageLoader({
  label = "Cargando…",
  variant = "inline",
  className,
}: PageLoaderProps) {
  return (
    <StructuraAppLoadingScreen
      productName={FM_APP_LOADING_BRAND.productName}
      badge={FM_APP_LOADING_BRAND.badge}
      message={label}
      variant={variant === "screen" ? "screen" : "embedded"}
      className={cn(className)}
    />
  );
}
